import React from "react";
import { LAYER_PROPS } from "./layer_const.js";
import MapboxColorPicker from '../component/MapboxColorPicker.jsx';
import MapboxHelpTooltip from "../component/MapboxHelpTooltip.jsx";
import InputWithJson from "../component/InputWithJson.jsx";
const SymbolPaint = ({updateField, layerField, index}) => {
    const textColor = LAYER_PROPS.symbol.paint['text-color']
    const paintVal = (layerField.symbol || {}).paint || {}
    return (
        <>
            { !paintVal.useJson && 
                <label className="col-xs-9 col-md-9" >
                    {textColor.title}
                    <MapboxHelpTooltip description={textColor.description} />
                    <MapboxColorPicker index={index} name={`layerFields.${index}.symbol.paint.text-color`} color={paintVal['text-color'] || textColor.default} />
                </label>
            }
            <InputWithJson 
                    withInput={true}
                    toggleSetting={{
                        useJson: paintVal.useJson,
                        setUseJson: (value) => updateField(`layerFields.${index}.symbol.paint.useJson`, value),
                        name: `layerFields.${index}.symbol.paint.useJson`
                    }}
                    jsonInputSetting={{
                        value: paintVal['text-color'],
                        updateJsonValue: (value) => updateField(`layerFields.${index}.symbol.paint.text-color`, value),
                        label: textColor.title,
                        description: textColor.description
                    }}
            />
        </>
    )
}

const CirclePaint = ({updateField, layerField, index}) => {
    const circleColor = LAYER_PROPS.circle.paint['circle-color']
    const circleRadius = LAYER_PROPS.circle.paint['circle-radius']
    const paintVal = (layerField.circle || {}).paint || {}
    return (
        <>
        {!paintVal.useRadiusJson && 
        <label className="col-xs-9 col-md-9">
          {circleRadius.title}
          <MapboxHelpTooltip description={circleRadius.description} />
          <input
            value={paintVal['circle-radius'] || circleRadius.default}
            type='number'
            data-index={index}
            className='form-control'
            onChange={(e) => updateField(`layerFields.${index}.circle.paint.circle-radius`, e.target.value)}
          />
        </label>}
        <InputWithJson 
                withInput={true}
                toggleSetting={{
                    useJson: paintVal.useRadiusJson,
                    setUseJson: (value) => updateField(`layerFields.${index}.circle.paint.useRadiusJson`, value),
                    name: `layerFields.${index}.circle.paint.useRadiusJson`
                }}
                jsonInputSetting={{
                    value: paintVal['circle-radius'],
                    updateJsonValue: (value) => updateField(`layerFields.${index}.circle.paint.circle-radius`, value),
                    label: circleRadius.title,
                    description: circleRadius.description
                }}
        />
        { !paintVal.useColorJson && 
        <label className="col-xs-9 col-md-9" >
            {circleColor.title}
            <MapboxHelpTooltip description={circleColor.description} />
            <MapboxColorPicker name={`layerFields.${index}.circle.paint.circle-color`} color={paintVal['circle-color'] || circleColor.default} />
        </label>
        }
        <InputWithJson 
                withInput={true}
                toggleSetting={{
                    useJson: paintVal.useColorJson,
                    setUseJson: (value) => updateField(`layerFields.${index}.circle.paint.useColorJson`, value),
                    name: `layerFields.${index}.circle.paint.useColorJson`
                }}
                jsonInputSetting={{
                    value: paintVal['circle-color'],
                    updateJsonValue: (value) => updateField(`layerFields.${index}.circle.paint.circle-color`, value),
                    label: circleColor.title,
                    description: circleColor.description
                }}
        />
        
      </>
    )
}

const HeatmapPaint = ({updateField, layerField, index}) => {
    const heatmapColor = LAYER_PROPS.heatmap.paint['heatmap-color']
    const heatmapRadius = LAYER_PROPS.heatmap.paint['heatmap-radius']
    const paintVal = (layerField.heatmap || {}).paint || {}
    return (
        <>
            { !paintVal.useRadiusJson && 
                <label className="col-xs-9 col-md-9" >
                    {heatmapRadius.title}
                    <MapboxHelpTooltip description={heatmapRadius.description} />
                    <input
                        value={paintVal['heatmap-radius']}
                        type='number'
                        data-index={index}
                        className='form-control'
                        onChange={(e) => updateField(`layerFields.${index}.heatmap.paint.heatmap-radius`, e.target.value)}
                    />
                </label>
            }
            <InputWithJson 
                    withInput={true}
                    toggleSetting={{
                        useJson: paintVal.useRadiusJson,
                        setUseJson: (value) => updateField(`layerFields.${index}.heatmap.paint.useRadiusJson`, value),
                        name: `layerFields.${index}.heatmap.paint.useRadiusJson`
                    }}
                    jsonInputSetting={{
                        value: paintVal['heatmap-radius'],
                        updateJsonValue: (value) => updateField(`layerFields.${index}.heatmap.paint.heatmap-radius`, value),
                        label: heatmapRadius.title,
                        description: heatmapRadius.description
                    }}
            />
            { !paintVal.useColorJson && 
                <label className="col-xs-9 col-md-9" >
                    {heatmapColor.title}
                    <MapboxHelpTooltip description={heatmapColor.description} />
                    <MapboxColorPicker name={`layerFields.${index}.heatmap.paint.heatmap-color`} color={paintVal['heatmap-color'] || heatmapColor.default} />
                </label>
            }
            <InputWithJson 
                    withInput={true}
                    toggleSetting={{
                        useJson: paintVal.useColorJson,
                        setUseJson: (value) => updateField(`layerFields.${index}.heatmap.paint.useColorJson`, value),
                        name: `layerFields.${index}.heatmap.paint.useColorJson`
                    }}
                    jsonInputSetting={{
                        value: paintVal['heatmap-color'],
                        updateJsonValue: (value) => updateField(`layerFields.${index}.heatmap.paint.heatmap-color`, value),
                        label: heatmapColor.title,
                        description: heatmapColor.description,
                        defaultJson: heatmapColor.defaultJson
                    }}
            />
        </>
    )
}

const RasterPaint = ({updateField, layerField, index}) => {
    return null
}

const SmartmeIconPaint = ({updateField, layerField, index}) => {
    return (
        <>
        </>
    )
}

const PAINT_TYPE_MAPPING = {
    symbol: (updateField, layerField, index) => {return <SymbolPaint updateField={updateField} layerField={layerField} index={index} />},
    circle: (updateField, layerField, index) => {return <CirclePaint updateField={updateField} layerField={layerField} index={index} />},
    heatmap: (updateField, layerField, index) => {return <HeatmapPaint updateField={updateField} layerField={layerField} index={index} />},
    raster: (updateField, layerField, index) => {return <RasterPaint updateField={updateField} layerField={layerField} index={index} />},
    customSmartmeIcon: (updateField, layerField, index) => {return <SmartmeIconPaint updateField={updateField} layerField={layerField} index={index} />}
}

const LayerPaint = ({layerField, updateField, index}) => {
    return PAINT_TYPE_MAPPING[layerField['type']](updateField, layerField, index) || null

}

export default LayerPaint